export const ROOT_ID = "bc-section-root";
export const DRAFT_PREFIX = "newsletter-draft-v1";
export const TEMPLATE_STORAGE_KEY = "newsletter-templates-v1";

export const PRESETS = [
  {
    key: "bookish",
    name: "Bookish Circle Classic",
    outerBg: "#F4E9D6",
    cardBg: "#ffffff",
    textColor: "#111111",
    accentColor: "#541675",
    fontFamily: "Georgia, serif",
    fontSize: "16px",
    contentWidth: "700px",
  },
  {
    key: "clean",
    name: "Clean Minimal",
    outerBg: "#f3f4f6",
    cardBg: "#ffffff",
    textColor: "#111827",
    accentColor: "#111827",
    fontFamily: "Arial, sans-serif",
    fontSize: "16px",
    contentWidth: "700px",
  },
];
